import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _QualityGarmentPiece } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    _idQualityGarment: number;
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectQualityGarmentPiece = ({ _idQualityGarment, idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityGarmentPiece);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (_idQualityGarment) {
            getLista();
        } else { setLista([]) }
    }, [_idQualityGarment]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDQualityGarmentPiece === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDQualityGarmentPiece,
                    label: `${found.DataBeanProperties.PieceCode} - ${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
            IDQualityGarment: _idQualityGarment
        }
        instance.getQualityGarmentPieceCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDQualityGarmentPiece,
        label: `${item.DataBeanProperties.PieceCode} - ${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Pieza de una prenda"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una pieza..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
